// extracted by mini-css-extract-plugin
export default {"socializatorWrapper":"HN_YQk45","_disableDividers":"dmzccIjL"};